// First we need to import axios.js
import axios from 'axios';

const instance = axios.create({
});

instance.interceptors.request.use(request => {
    return request;
}, error => {
    return Promise.reject(error);
});

instance.interceptors.response.use(response => {
    if (response?.data?.status === 'success') {
        return response.data.data;
    }
    return Promise.reject(response?.data || {
        status: 'error',
        message: 'Request failed',
    });
}, error => {
    console.log('reject error ==', error);
    const data = error?.response?.data;
    if (data && typeof data === 'object') {
        return Promise.reject(data);
    }
    return Promise.reject({
        status: 'error',
        message: error?.message || 'Request failed',
        statusCode: error?.response?.status,
    });
});

export default instance;
